'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { FeatherEye, FeatherLogOut, FeatherPackage } from '@subframe/core';
import { Button } from '@/shared/components/ui/common/Button';
import type { ImpersonateBarProps } from '@/features/admin-geral/types/uiTypes';
export const ImpersonateBar: React.FC<ImpersonateBarProps> = t0 => {
  const $ = _c(20);
  const {
    userNome,
    tenantNome,
    onExit,
    onAbrirPlano
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20"><FeatherEye className="h-4 w-4 text-white" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== userNome) {
    t2 = <p className="text-sm font-medium">Visualizando como <span className="font-bold">{userNome}</span></p>;
    $[1] = userNome;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== tenantNome) {
    t3 = <p className="text-xs text-white/80">{tenantNome}</p>;
    $[3] = tenantNome;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex items-center gap-3">{t1}<div className="flex flex-col">{t2}{t3}</div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherPackage />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onAbrirPlano) {
    t6 = <Button variant="neutral-secondary" size="small" icon={t5} onClick={onAbrirPlano}>Plano e consumo</Button>;
    $[9] = onAbrirPlano;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FeatherLogOut />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== onExit) {
    t8 = <Button variant="neutral-secondary" size="small" icon={t7} onClick={onExit}>Sair da Visualização</Button>;
    $[12] = onExit;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <div className="flex items-center gap-2">{t6}{t8}</div>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t4 || $[18] !== t9) {
    t10 = <div className="bg-brand-600 animate-fade-in flex w-full items-center justify-between px-6 py-2 text-white shadow-lg">{t4}{t9}</div>;
    $[17] = t4;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};